<template>
  <div></div>
</template>
<script>
import API from '@/api';

export default {
  name: 'partner-handler',
  mounted() {
    const partnerCode = this.$router.currentRoute.path.substr(1);
    API.getPartner(partnerCode).then((resp) => {
      this.$store.dispatch('setPartner', resp).then(() => {
        this.$router.push('/user-info');
      });
    });
  },
};
</script>
